import { render, staticRenderFns } from "./MyMediaAccreditation.vue?vue&type=template&id=0de87e56&scoped=true"
import script from "./MyMediaAccreditation.vue?vue&type=script&lang=js"
export * from "./MyMediaAccreditation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de87e56",
  null
  
)

export default component.exports